import script from "./Distribution.vue?vue&type=script&setup=true&lang=js"
export * from "./Distribution.vue?vue&type=script&setup=true&lang=js"

import "./Distribution.vue?vue&type=style&index=0&id=103b5fca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-103b5fca"]])

export default __exports__